import styled from 'styled-components';

import { colors, fonts } from '../../../../../theme';

export const CellDateSubtitle = styled.div`
    ${fonts.textSmall};
    color: ${colors.textColorOpacity};
`;
